import { createFileRoute } from "@tanstack/react-router";
import AlreadyTriedTms from "@/pages/AlreadyTriedTms";
export const Route = createFileRoute("/already-tried-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Already Tried TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "If standard TMS didn’t work, SAINT accelerated TMS and other options may help. Learn what to try next for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Already Tried TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "If standard TMS didn’t work, SAINT accelerated TMS and other options may help. Learn what to try next for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/already-tried-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/already-tried-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AlreadyTriedTms />;
}
